import styled from 'styled-components';
import {PcBox as BasePcBox, MobileBox as BaseMobileBox} from './dialog-overlay.default.box';
import { CssRule } from '../../../../themes/architecture/css-helpers/css-rule';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';


const PcBox = styled(BasePcBox)`
    background-color: rgba(252, 246, 213, 0.85);
`;

const MobileBox = styled(BaseMobileBox)`
    background-color: rgba(252, 246, 213, 1);
    
    ${CssRule.For.mobile.tablet.build()} & {
        background-color: rgba(252, 246, 213, 0.85);        
    }
`;

export const DialogOverlayCasino777Box = styledByDevice(PcBox, MobileBox);